export const environment = {
    production: true,
 HOST : 'https://www.andreagt.com/sic-backend',
  // HOST : 'http://localhost:8090',
 HOST_ERP:'https://storenew-001-site3.atempurl.com/api',
 //HOST : 'v0',
//HOST:'v1',
  //HOST_ERP:'v2',
     TOKEN_NAME : 'access_token',
     TOKEN:'eyJhbGciOiJIUzUxMiJ9.eyJpYXQiOjE3MTA4NTk3MTIsImV4cCI6MTcxMDk0NjExMn0.5kaU2QGLKiHxGYVXvbuUu1rN9R3cpgHhhz_OpEAMPvLUgiu0aK1zHfGhegVRumZNg-NVQgk1V6X8XBEeI-qp4w',
     REINTENTOS : 2,
     firebase:{
       apiKey: "AIzaSyCIMmqfHiekiCaiisv-CFx6g9jYSOmT2ys",
       authDomain: "pushnotificationdemo-ca822.firebaseapp.com",
       projectId: "pushnotificationdemo-ca822",
       storageBucket: "pushnotificationdemo-ca822.appspot.com",
       messagingSenderId: "295046595980",
       appId: "1:295046595980:web:33e7657f0594f49bcd82a9",
       measurementId: "G-6CN3Y8M9ZL"
     },
     
 


};
